import { createRouter } from "@tanstack/react-router"

import type { AuthContextType } from "./providers/auth-provider"
import { routeTree } from "./routeTree.gen"

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  context: {
    // Set by RouterProviderWithContext once useAuth() resolves.
    auth: undefined as unknown as AuthContextType,
  },
})

declare module "@tanstack/react-router" {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Register {
    router: typeof router
  }
}
